import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './badge.js';

const statusBadgeCss = "tt-badge[data-status=waiting]::part(base){background-color:var(--tt-color-yellow-400);color:var(--tt-color-black)}tt-badge[data-status=new]::part(base){background-color:var(--tt-color-green-400);color:var(--tt-color-white)}tt-badge[data-status=published]::part(base){background-color:var(--tt-color-green-700);color:var(--tt-color-white)}tt-badge[data-status=unpublished]::part(base){background-color:var(--tt-color-yellow-400);color:var(--tt-color-black)}tt-badge[data-status=scheduled]::part(base){background-color:var(--tt-color-green-700);color:var(--tt-color-white)}tt-badge[data-status=draft]::part(base){background-color:var(--tt-color-yellow-400);color:var(--tt-color-black)}tt-badge[data-status=upcoming]::part(base){background-color:var(--tt-color-green-400);color:var(--tt-color-white)}tt-badge[data-status=ondemand]::part(base){background-color:var(--tt-color-green-700);color:var(--tt-color-white)}tt-badge[data-status=live]::part(base){background-color:var(--tt-color-red-400);color:var(--tt-color-white)}tt-badge[data-status=waitingroom]::part(base){background-color:var(--tt-color-orange-300);color:var(--tt-color-white)}tt-badge[data-status=cancelled]::part(base){background-color:var(--tt-color-gray-1000);color:var(--tt-color-white)}tt-badge[data-status=past]::part(base){background-color:var(--tt-color-gray-500);color:var(--tt-color-white)}tt-badge[data-status=template]::part(base){background-color:var(--tt-color-blue-500);color:var(--tt-color-white)}tt-badge[data-status=private]::part(base){background-color:var(--tt-color-purple-500);color:var(--tt-color-white)}tt-badge[data-status=secret]::part(base){background-color:var(--tt-color-black);color:var(--tt-color-white)}tt-badge[data-status=deleted]::part(base){background-color:var(--tt-color-gray-100);color:var(--tt-color-black)}";

// Map for custom status labels
const statusLabelMap = {
  waiting: 'Waiting',
  new: 'New',
  published: 'Published',
  unpublished: 'Unpublished',
  scheduled: 'Scheduled',
  draft: 'Draft',
  upcoming: 'Upcoming',
  ondemand: 'On Demand',
  live: 'Live',
  waitingroom: 'Waiting Room',
  cancelled: 'Cancelled',
  past: 'Past',
  template: 'Template',
  private: 'Private',
  secret: 'Secret',
  deleted: 'Deleted',
};
const StatusBadge = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.status = undefined;
  }
  render() {
    var _a;
    return h("tt-badge", { "data-status": this.status }, (_a = statusLabelMap[this.status]) !== null && _a !== void 0 ? _a : 'Invalid');
  }
  static get style() { return statusBadgeCss; }
}, [1, "tt-status-badge", {
    "status": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-status-badge", "tt-badge"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-status-badge":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, StatusBadge);
      }
      break;
    case "tt-badge":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtStatusBadge = StatusBadge;
const defineCustomElement = defineCustomElement$1;

export { TtStatusBadge, defineCustomElement };
